import type { CSSProperties } from 'react';

import type { DropdownIndicatorProps, GroupBase } from 'react-select-5';

import ArrowUp from 'components/shared/Icon/icons/ArrowUp';

export function DropdownIndicator<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>,
) {
  const { innerProps, getClassNames, getStyles } = props;
  return (
    <div
      {...innerProps}
      className={getClassNames('dropdownIndicator', props)}
      style={getStyles('dropdownIndicator', props) as CSSProperties}
    >
      <ArrowUp width="14" height="14" style={{ transform: 'rotate(180deg)' }} />
    </div>
  );
}
